import { render } from "./attribute-part-card.html?vue&type=template&id=a7332246&scoped=true&ts=true"
import script from "./attribute-part-card.ts?vue&type=script&lang=ts"
export * from "./attribute-part-card.ts?vue&type=script&lang=ts"

import "./attribute-part-card.scss?vue&type=style&index=0&id=a7332246&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7332246"]])

export default __exports__